import React from "react";
import { InputGroup, FormControl } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";

interface Props {
    value: string;
    onChange: (v: string) => void;
    placeholder?: string;
}

export default function SearchBar({ value, onChange, placeholder }: Props) {
    return (
        <InputGroup className="mb-3">
            <InputGroup.Text className="bg-white">
                <FontAwesomeIcon icon={faSearch} className="text-muted" />
            </InputGroup.Text>
            <FormControl
                placeholder={placeholder || "Search by center code..."}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                aria-label="Search centers"
            />
        </InputGroup>
    );
}
